<template>
    <!-- 广播资源管理 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/broadcast_resources'}"  @click="$Common.pageJump('/broadcast_resources',3)">
                广播资源
            </li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/system_broadcast'}" @click="$Common.pageJump('/system_broadcast',3)">
                系统广播
            </li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/broadcast_play_record'}" @click="$Common.pageJump('/broadcast_play_record',3)">
                播放记录
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name:'BroadcastResourceManagement',
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
    },
    mounted() {
    },
};
</script>
<style scoped>
</style>